import type { gsap } from 'gsap';

export default (gsap: gsap): () => void => {
  const init = (el: HTMLElement) => {

    gsap.set(el, {
      opacity: 0,
    });

    gsap.to(el, {
      opacity: 1,
      scrollTrigger: {
        trigger: el,
        start: () => {
          const bb = el.getBoundingClientRect();
          const posOfElementFromBottom = document.body.scrollHeight - (window.scrollY + bb.top);
          return posOfElementFromBottom > window.innerHeight * 0.5 ?  'top center' : 'top bottom-=100';
        },
        markers: window.location.host === 'x.ddev.site',
        invalidateOnRefresh: true,
      },
    });
  };

  (document.querySelectorAll('.icon-arrow:not(.icon-arrow--banner)') as NodeListOf<HTMLElement>).forEach(init);

  const iconArrowBanner = document.querySelectorAll('.icon-arrow-wrapper--banner');

  if (iconArrowBanner) {
    gsap.set(iconArrowBanner, {
      opacity: 0,
      rotate: 20,
    });

    gsap.to(iconArrowBanner, {
      opacity: 1,
      rotate: 0,
      delay: 2,
    });
  }

  // cleanup function - executes when media not matched
  return () => {
    gsap.set('.icon-arrow', {
      opacity: 1,
    });
  };
};
